import { Popover, SecondaryButton } from '@cko/primitives';
import styled from 'styled-components';

export const PopoverTriggerContainer = styled.div`
  position: fixed;
  top: 15px;
  right: 50%;
  z-index: var(--z-order-floating-element);
`;

export const StyledPopover = styled(Popover)`
  min-height: 50%;
  min-width: 50%;
  z-index: 99999;
`;

export const StyledPopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: stretch;
  justify-content: stretch;
  gap: var(--layout-soybean);
  width: 50vw;
  height: 75vh;
`;

export const StyledStatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  background: var(--control-text-warn);
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
`;

export const StyledSecondaryButton = styled(SecondaryButton)<{ hasOverrides: boolean }>`
  height: var(--layout-shoe);
  color: ${({ hasOverrides }) => (hasOverrides ? 'var(--control-text-warn)' : 'currentColor')};
`;

export const StyledBadge = styled.span`
  -webkit-box-align: center;
  align-items: center;
  color: var(--control-text-warn);
  font-size: var(--body-xs-medium);
  padding-inline: var(--layout-seed);
`;
